import React from "react";

const InputField = React.forwardRef(
  (
    {
      label,
      id,
      extra = "",
      type = "text",
      placeholder = "",
      variant = "auth",
      state,
      disabled = false,
      error, // only used for error text, not input styling
      className = "",
      ...rest
    },
    ref
  ) => {
    const base =
      "mt-0.5 flex h-9 w-full items-center justify-center rounded-md border bg-white/0 p-3 text-sm outline-none";
    const stateClasses = disabled
      ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
      : state === "success"
      ? "border-green-500 text-green-600 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
      : "border-gray-200 dark:!border-white/10 dark:text-white";

    return (
      <div className={`${extra}`}>
        {label && (
          <label
            htmlFor={id}
            className={`text-sm text-navy-700 dark:text-white ${
              variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
            }`}
          >
            {label}
          </label>
        )}

        <input
          ref={ref}
          id={id}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          className={`${base} ${stateClasses} ${className}`}
          {...rest}
        />

        {error && (
          <p className="mt-0.5 ml-1.5 text-sm text-red-500">
            {typeof error === "string" ? error : error.message}
          </p>
        )}
      </div>
    );
  }
);

InputField.displayName = "InputField";
export default InputField;
